import styles from './index.less';
import { useEffect, useState } from 'react';
import NoData from '@/components/NoData';
import {  viewWechatGuide } from '@/service/banner';
import { Helmet, useLocation } from '@umijs/max';
import { Card } from 'react-vant';

const WorkGuideDetail = () => {
  console.log(666, useLocation());
  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');

  console.log(data)
  const [WorkGuideData, setWorkGuideData] = useState<any>({});
  useEffect(() => {
    viewWechatGuide({sequenceNbr: data}).then((res) => {
      console.log(res);
      if (res && res.code === 200 && res.data) {
        setWorkGuideData(res.data);
      } else {
        setWorkGuideData({});
      }
    });
    
  }, [data]);

  return (
    <div className={styles['aboutPropertyDetail']}>
      <Helmet>
        <title>办事指南详情</title>
      </Helmet>
      <div>
        {Object.entries(WorkGuideData).length ? (
          <>
            <div className={styles['datailsBox']}>
              <div className={styles['title']}>{WorkGuideData.title}</div>
              <div className={styles.time}>
                <div>发布时间：</div>
                <div>{WorkGuideData.publishTime}</div>
              </div>
              <div className={styles.quetionContaner}>
                <Card round>
                      <Card.Body>
                        <div
                          className={styles.content}
                          dangerouslySetInnerHTML={{
                            __html: WorkGuideData.content,
                          }}
                        ></div> 
                        </Card.Body>
                  </Card>
               </div>
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default WorkGuideDetail;
